/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseControl from './BaseControl.vue';

/**
 * Base component to wrap text inputs with a common markup.
 *
 * It has all `BaseControl` options plus:
 *
 * @vue-prop {String} [type="text"] the type of the input
 *
 * @example
 *
 * base-input(:label="t('name')" type="text" v-model="form.name" validations="required" name="name")
 *
 * @category ui.components.form-elements
 * @exports BaseInput
 * @component
 */
const __vue_script__ = {
    name: 'BaseInput',

    extends: BaseControl,

    props: {
        type: {
            type: String,
            default: 'text'
        },

        value: {
            type: [String, Number],
            default: null
        },

        placeholderIconClass: {
            type: String,
            default: null
        },

        hideErrors: {
            type: Boolean,
            default: false
        },

        maxlength: {
            type: Number,
            default: null
        },

        wrapperClass: {
            type: String,
            default: null
        },

        autofocus: {
            type: Boolean,
            default: false
        },

        autoselect: {
            type: Boolean,
            default: false
        },

        avoidPasswordManagers: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        decoratorErrors() {
            return this.hideErrors ? undefined : this.errors;
        },

        passwordManagerAttrs() {
            const attrs = {
                autocomplete: this.avoidPasswordManagers ? 'off' : this.autocomplete
            };

            if (this.avoidPasswordManagers) {
                attrs['data-form-type'] = 'other';
                attrs['data-1p-ignore'] = '';
                attrs['data-lpignore'] = 'true';
                attrs['data-bwignore'] = '';
            }

            return attrs;
        },

        inputAttrs() {
            return {
                ...this.$attrs,
                ...this.passwordManagerAttrs
            };
        }
    },

    mounted() {
        this.$nextTick(() => {
            if (this.autofocus) {
                this.$refs.input?.focus();
            }

            if (this.autoselect) {
                this.$refs.input?.select();
            }
        });
    },

    methods: {
        /**
         * Gets the prover control value (type aware)
         *
         * @param {Event} [$event] the event coming from the window
         *
         * @returns {String|Number} the value with the proper type
         */
        getTypedValue($event) {
            let value = this.value;

            if ($event?.target) {
                value = $event.target.value;
            }

            if (value && this.type === 'number' && value !== '-') {
                value = this.$utils.strings.toNumber(value);
            }

            return value;
        },

        /**
         * Triggered when user interacts with selects component.
         * Overrides base control in order to still have change
         *
         * @param {Object} $event the event that triggered the change
         */
        change($event) {
            this.$emit('change', this.getTypedValue($event));
        },

        /**
         * Triggered when user interacts with input components.
         *
         * @param {Object} [$event] the event that triggered the change
         */
        input($event) {
            this.$emit('input', this.getTypedValue($event));
        },

        /**
         * Triggered when user focuses the input component.
         *
         * @param {Object} $event the event that triggered the change
         */
        focus($event) {
            this.$emit('focus', this.getTypedValue($event));
        },

        /**
         * Triggered when user unfocuses the input component.
         *
         * @param {Object} $event the event that triggered the change
         */
        blur($event) {
            this.$emit('blur', this.getTypedValue($event));
        },

        /**
         * Selects the text in the input element.
         */
        select() {
            this.$refs.input.select();
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-decorator',{attrs:{"label":_vm.label,"tip":_vm.tip,"hint":_vm.hint,"uid":_vm.uid,"errors":_vm.decoratorErrors,"hint-after-label":_vm.hintAfterLabel,"warning":_vm.warning,"dependant":_vm.dependant},scopedSlots:_vm._u([{key:"after-label",fn:function(ref){return [_vm._t("after-label")]}},{key:"default",fn:function(ref){
var _obj;
return [_c('div',{staticClass:"input-wrapper",class:( _obj = {'with-content': _vm.$slots.default }, _obj[_vm.wrapperClass] = _vm.wrapperClass, _obj )},[(_vm.placeholderIconClass)?_c('i',{staticClass:"input-left-icon",class:_vm.placeholderIconClass}):_vm._e(),_c('input',_vm._g(_vm._b({ref:"input",staticClass:"notranslate form-control",class:{'has-error': _vm.errors.length, 'has-warning': _vm.warning, 'with-icon': !!_vm.placeholderIconClass},attrs:{"id":_vm.uid,"name":_vm.name,"type":_vm.type,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"aria-label":_vm.placeholder && !_vm.label ? _vm.placeholder : null,"maxlength":_vm.maxlength},domProps:{"value":_vm.value},on:{"input":_vm.input,"change":_vm.change,"focus":_vm.focus,"blur":_vm.blur}},'input',_vm.inputAttrs,false),_vm.listeners)),_vm._t("default"),_vm._t("extra")],2)]}},{key:"inside-label",fn:function(ref){return [_vm._t("inside-label")]}}],null,true)})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "BaseInput.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__